import sebastianPic from "@/public/images/artists/sebastian.png";
import { Artist } from "@/types/types";

export const sebastian = {
  id: "42",
  name: "Sebastian",
  image: sebastianPic,
  description: `Introducing "Sebastian," the pop sensation who's breaking the mold. With a voice that's equal parts edgy and powerful, Sebastian adds a refreshing twist to the pop music landscape. His unique style and infectious energy make every song a delightful adventure.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fsebastian-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["RnB", "Pop", "Falsetto", "Airy"],
      secondary: ["Singer"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 49,
        high: 69,
      },
    },
  },
} as const satisfies Artist;
